import '../index.scss';

function Buying() {
  return (
    <div className="payment_term">
      <h1 className="page-title">Consent to confirming purchases</h1>
      <div className="page-body">
        <p>
          I have confirmed the lecture title(강의명), price, delivery information of the goods order and hereby give my
          consent.
        </p>
      </div>
    </div>
  );
}

export default Buying;
